<template>
   <b-card style="margin-bottom: 2rem">
      <div class="d-flex align-items-center justify-content-between">
         <h2 class="mb-0">Flags and Issues</h2>

         <div class="d-flex align-items-center">
            <b-button
               id="btn-flags"
               variant="primary"
               :to="{name: 'flags-and-issues-staff', params: {id: $companyId}}"
            >
               View
            </b-button>
         </div>
      </div>
   </b-card>
</template>

<script>
export default {
   name: 'FlagsCard',
};
</script>
